import ResultResponseInterface, { resultResponseInitialValue } from "@/types/app/resultResponse";
import * as Sentry from "@sentry/vue";
import Swal from "sweetalert2";

export default class ErrorService {
    constructor() {
        ErrorService.initHandler();
    }

    static onError(data:any) : ResultResponseInterface {
        ErrorService.sentryLogEngine(data)
        const response = data?.response;
        if (response && response.status >= 400 && response.status < 405) {
            // You can handle this differently
            ErrorService.sentryLogEngine(data);
        }
        else 
        // Send Error to Log Engine e.g LogRocket
            ErrorService.logRocketLogEngine(data);
        ErrorService.displayErrorAlert(data);

        if(response && response.data)
           return response.data as ResultResponseInterface;
        else {
          const result = resultResponseInitialValue;
          result.hasErrors  = true;
          return result;
        }
    }

    static onWarn(error: any) {
        // Send Error to Log Engine e.g LogRocket
        ErrorService.logRocketLogEngine(error);
    }

    static onInfo(error: any) {
        // You can handle this differently
        ErrorService.sentryLogEngine(error);
    }

    static onDebug(data: any) {
        const response = data?.error?.response;
        if (response && response.status >= 400 && response.status < 405) {          
            ErrorService.sentryLogEngine(data);            
        }
        // Send Error to Log Engine e.g LogRocket
        else ErrorService.logRocketLogEngine(data);
        
    }

    static initHandler() {
        window.onerror = (message, url, lineNo, columnNo, error) => {
            if (error) {
                ErrorService.onError(error);
            }
        };
    }
    static getMessage(errors:any):string{
        let message = 'Internal error';
        if (!(errors instanceof Array)) {
            const keys = Object.keys(errors);
            keys.forEach(element => {
                message += errors[element] + '';
            });
        }
        else message = (errors as []).join('\r\n');
        return message;
    }
    static displayErrorAlert(data:any) {
        const response = data?.response?.data?.response?.error;
        let message = 'Internal error';
        
        if (response?.data?.errors)
        {
            message = ErrorService.getMessage(response?.data?.errors);
        }
        else if (response?.errors)
            message = ErrorService.getMessage(response?.errors);
        else if(data?.errors){
            message = ErrorService.getMessage(data?.errors);
        }
        
        Swal.fire({
            title: "Error!",
            text: message,
            icon: "error",
        });
    }

    static logRocketLogEngine(error: any) {
        // Implement LogRocket Engine here
        Sentry.captureException(error);
    }

    static sentryLogInfo(message: string) {
        // Implement LogRocket Engine here
        Sentry.captureMessage(message);
    }

    static sentryTraceInfo(method: string, duration:number) {
        // Implement LogRocket Engine here
        Sentry.captureMessage(`Call to ${method} took ${duration} milliseconds.`);
    }

    static sentryLogEngine(error: any) {
        // Implement Sentry Engine here
        Sentry.captureException(error);
    }
}